<template src="./InactiveEmployeesReport.html"></template>

<script>
import mixins from "../../../../Mixins"
export default {
  name: "inactive-employees-report",
  mixins: [mixins],
  data() {
    return {
      employees: [],
      noDataText: "Aguarde, estamos carregando as informações...",
      windowWidth: 0,
      pagination: false,
      currentx: 1,
      numPages: 0,
      searchEmployee: "",
    }
  },
  watch: {
    currentx: function () {
      this.getEmployees()
    },
  },
  mounted: function () {
    this.init();
  },
  created() {
    window.addEventListener("resize", this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize)
  },
  methods: {
    init() {
      this.getEmployees()
    },
    getEmployees() {
      this.noDataText = "Aguarde, estamos carregando as informações..."
      this.axios.get(
        `${this.$store.state.filooServer}bi/vwBiInactiveEmployees?search=${this.searchEmployee}&page=${this.currentx-1}&size=10`,
        {
          headers: { Authorization: this.$session.get("bearer") },
        }
      )
      .then( resp => {
        this.employees = resp.data.content
        for (const key in this.employees) {
          this.employees[key].phone = this.maskCelPhone(this.employees[key].phone)
        }
        this.numPages = resp.data.totalPages
        this.pagination = this.numPages > 1
        this.noDataText = "Nenhum resultado encontrado"
      })
      .catch( error => {
        this.noDataText = "Nenhum resultado encontrado"
        console.log({
          location: "getEmployees",
          error: error,
        })
      })
    },
    handleSearch(searching) {
      this.searchEmployee = searching
      this.getEmployees()
    },
    handleResize() {
      this.windowWidth = window.innerWidth
    },
  }
}
</script>

<style lang="scss" src="./InactiveEmployeesReport.scss">
</style>
